class Anchor {
  constructor() {
    this.anchorTriggers = document.querySelectorAll('.js-anchor');
    this.adjustDistance = 20;
    this.init();
  }

  init() {
    if (!this.anchorTriggers.length) return;

    this.anchorTriggers.forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();

        const href = anchor.getAttribute('href');
        // '#' のみ、またはページ内リンクでない場合はスキップ
        if (!href || href === '#' || !href.startsWith('#')) return;
        const target = document.querySelector(href);
        if (!target) return;
        const scrollVolume = target.getBoundingClientRect().top + window.scrollY - this.adjustDistance;
        window.scrollTo({ top: scrollVolume, behavior: 'smooth' });
      });
    });
  }
}

export default Anchor;
